import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, ArrowLeft } from 'lucide-react';
import ReviewsList from './ReviewsList';
import { Button } from './button';

const API_URL = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : '/api';

// Public list of approved reviews. Linked from the LandingPage strip.
const ReviewsPage = () => {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const r = await fetch(`${API_URL}/reviews?limit=200`);
                if (!r.ok) throw new Error('Failed to load reviews');
                const data = await r.json();
                if (!cancelled) setReviews(data.reviews || []);
            } catch (e) {
                if (!cancelled) setError(e.message);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, []);

    return (
        <div className="container mx-auto px-4 max-w-5xl py-8">
            <Link to="/">
                <Button variant="ghost" size="sm" className="mb-4 rounded-xl">
                    <ArrowLeft className="h-4 w-4 mr-1" />
                    Back
                </Button>
            </Link>
            <h1 className="text-2xl lg:text-3xl font-bold mb-6">What people are saying</h1>

            {loading ? (
                <div className="flex justify-center py-12">
                    <Loader2 className="h-6 w-6 animate-spin text-gray-400" />
                </div>
            ) : error ? (
                <p className="text-red-500 text-center py-8">{error}</p>
            ) : (
                <ReviewsList reviews={reviews} />
            )}
        </div>
    );
};

export default ReviewsPage;
